import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import {
  Actividad,
  ActividadGrupoEspecie,
  CheckItem,
  CurrentEmpresa
} from '@rpe/registro-personas-empresas-lib';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../core/core.module';
import { GrupoEspecieTipoActividad } from '../../../actividades/entity-grupos-especie-tipo-actividad/grupos-especie-tipo-actividad.model';
import { GruposEspecieTipoActividadService } from '../../../actividades/entity-grupos-especie-tipo-actividad/grupos-especie-tipo-actividad.service';
import {
  createEmptyGrupoEspecieFormInput,
  GrupoEspecieFormInput
} from '../../../actividades/entity-grupos-especie/grupo-especie.model';
import { GrupoEspecie } from '../../../actividades/entity-grupos-especie/grupos-especie.model';
import { GruposEspecieService } from '../../../actividades/entity-grupos-especie/grupos-especie.service';
import {
  createEmptyLaboratorioFormInput,
  Laboratorio
} from '../../../actividades/entity-laboratorios/laboratorios.model';
import { selectAllLaboratorios } from '../../../actividades/entity-laboratorios/laboratorios.selectors';
import { selectStepperActividad } from '../../../actividades/entity-stepper/stepper.selectors';
import { SubActividadEspecie } from '../../../actividades/entity-sub-actividades-especie/sub-actividades-especie.model';
import { selectAllSubActividadesEspecie } from '../../../actividades/entity-sub-actividades-especie/sub-actividades-especie.selectors';
import { SubActividad } from '../../../actividades/entity-sub-actividades/sub-actividades.model';
import { selectAllSubActividades } from '../../../actividades/entity-sub-actividades/sub-actividades.selectors';
import { TipoAnalisisLaboratorio } from '../../../actividades/entity-tipos-analisis-laboratorio/tipos-analisis-laboratorio.model';
import { TipoDivisorMuestra } from '../../../actividades/entity-tipos-divisor-muestra/tipos-divisor-muestra.model';
import { TipoEquipamientoLaboratorio } from '../../../actividades/entity-tipos-equipamiento-laboratorio/tipos-equipamiento-laboratorio.model';
import { TipoSubActividad } from '../../../actividades/entity-tipos-sub-actividad/tipos-sub-actividad.model';
import { TipoSubActividadService } from '../../../actividades/entity-tipos-sub-actividad/tipos-sub-actividad.service';
import {
  createEmptyRegistroActividadAcreditacionFormInput,
  RegistroActividadAcreditacionItemFormInput
} from '../../../actividades/registro-actividad-acreditacion/registro-actividad-acreditacion.model';
import { selectAllCurrentEmpresa } from '../../../empresas/entity-mis-empresas/entity-current-empresa.selectors';

import { State } from '../../../vista-usuario/vista-usuario.state';
import { selectAllActividadesGrupoEspecie } from '../../../actividades/entity-actividades-grupo-especie/entity-actividades-grupo-especie.selectors';
import { selectAllActividades } from '../../../actividades/entity-actividades/entity-actividades.selectors';
import { Especie } from '../../../actividades/entity-especies/especies.model';
import { selectAllEspecies } from '../../../actividades/entity-especies/especies.selectors';

@Component({
  selector: 'rpe-vista-stepper-registro-actividad-container',
  templateUrl: './vista-stepper-registro-actividad-container.component.html',
  styleUrls: ['./vista-stepper-registro-actividad-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VistaStepperRegistroActividadContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  @ViewChild(MatStepper) stepper: MatStepper;

  data: any;
  almacenamientoTabsData: any;
  actividadesMapa: Map<number, Actividad>; //mapa con key tipoActividadId
  actividades$: Observable<Actividad[]>;
  gruposEspecie$: Observable<GrupoEspecie[]>;
  gruposEspecieTipoActividad$: Observable<GrupoEspecieTipoActividad[]>;
  laboratorios$: Observable<Laboratorio[]>;
  tipoSubActividad$: Observable<TipoSubActividad[]>;
  tipoDivisorMuestra$: Observable<TipoDivisorMuestra[]>;
  tipoAnalisisLaboratorio$: Observable<TipoAnalisisLaboratorio[]>;
  tipoEquipamientoLaboratorio$: Observable<TipoEquipamientoLaboratorio[]>;
  subActividades$: Observable<SubActividad>[];

  gEFITA: Map<number, GrupoEspecieFormInput>;
  // tipoSubActividadInput = createEmptyTipoSubActividadFormInput();

  regActAcreFormInput = createEmptyRegistroActividadAcreditacionFormInput();

  laboratorioFormInput = createEmptyLaboratorioFormInput();
  idEmpresa: number;
  private subscription: Subscription | undefined;
  subscriptions: Subscription[] = [];

  produccionFormControl: FormGroup;

  constructor(
    private store: Store<State>,
    private gruposEspecieService: GruposEspecieService,
    private gruposEspecieTipoActividadService: GruposEspecieTipoActividadService,
    private tipoSubActividadService: TipoSubActividadService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.gruposEspecie$ = this.gruposEspecieService.entities$;
    this.laboratorios$ = this.store.select(selectAllLaboratorios);

    this.gruposEspecieTipoActividad$ =
      this.gruposEspecieTipoActividadService.entities$;
    this.tipoSubActividad$ = this.tipoSubActividadService.entities$;
  }
  formInputExperimentacion: GrupoEspecieFormInput;
  firstFormGroup: FormGroup = null;

  ngOnInit(): void {
    let resultado = combineLatest([
      combineLatest([
        this.gruposEspecie$,
        this.gruposEspecieTipoActividad$,
        this.store.pipe(select(selectAllSubActividades)),
        this.store.pipe(select(selectAllSubActividadesEspecie)),
        this.tipoSubActividad$,
        this.store.pipe(select(selectAllActividades))
      ]),
      combineLatest([
        this.store.pipe(select(selectAllCurrentEmpresa)),
        this.laboratorios$,
        this.store.pipe(select(selectAllEspecies)),
        this.store.pipe(select(selectAllActividadesGrupoEspecie))
      ])
    ]).pipe(
      map(([r1, r2]) => {
        return [...r1, ...r2] as [
          GrupoEspecie[],
          GrupoEspecieTipoActividad[],
          SubActividad[],
          SubActividadEspecie[],
          TipoSubActividad[],
          Actividad[],
          CurrentEmpresa[],
          Laboratorio[],
          Especie[],
          ActividadGrupoEspecie[]
        ];
      })
    );
    this.subscription = resultado.subscribe(
      ([
        grupoEspecie,
        grupoEspecieTipoActividad,
        subactividades,
        subActividadesEspecie,
        tiposSubActividad,
        actividades,
        currentEmpresa,
        laboratorios,
        especies,
        actividadesGruposEspecie
      ]) => {
        if (currentEmpresa.length > 0) {
          this.idEmpresa = currentEmpresa[currentEmpresa.length - 1].id;

          //mapa con key tipoActividad (se supone que son unicos)
          const actFiltradas = actividades.filter(
            (a) => a.entidad_productiva_id == this.idEmpresa
          );
          this.actividadesMapa = new Map();

          //arma los input a ser enviados a cada tipoactividad
          this.gEFITA = new Map();

          for (const aF of actFiltradas) {
            //agrega al mapa  de actividades
            this.actividadesMapa.set(aF.tipo_actividad_id, aF);

            this.gEFITA.set(
              aF.tipo_actividad_id,
              createEmptyGrupoEspecieFormInput()
            );
            let getaFilter = grupoEspecieTipoActividad.filter(
              (gETA) => gETA.tipo_actividad_id == aF.tipo_actividad_id
            );
            //por cada grupoEspecieActividad se arman las listas de grupoEspecie
            for (const eta of getaFilter) {
              let ge = grupoEspecie.find((ge) => eta.grupo_especie_id == ge.id);
              const encontrado = actividadesGruposEspecie.find(
                (aGE) =>
                  aGE.actividad_id == aF.id &&
                  aGE.grupo_especie_id == eta.grupo_especie_id
              );
              const auxCI = {
                id: encontrado ? encontrado.id : null,
                tipo_id: ge.id,
                nombre: ge.nombre,
                selected: encontrado != undefined
              };

              this.gEFITA.get(aF.tipo_actividad_id).listaCheckItem.push(auxCI);
            }
            //this.gEFITA.get(aF.tipo_actividad_id).actividadId = aF.id;
          }

          //el laboratorio recibe otro input
          this.laboratorioFormInput = {
            ...this.laboratorioFormInput,
            /*tipos_divisor_muestra: tiposDivisorMuestra,
            especies: especies,
            tipos_equipos_laboratorio: tiposEquipamientoLaboratorio,
            tipos_analisis_laboratorio: tiposAnalisisLaboratorio,*/
            laboratorios: laboratorios
          };

          // ACREDITACION
          // Si la empresa tiene el tipo de actividad acreditacion
          if (this.actividadesMapa.get(10)) {
            //arma los subtipos para acctividad acreditacion
            let tSAFilter = tiposSubActividad.filter(
              (geta) => geta.tipo_actividad_id == 10
            );
            //Reglas de negocio
            tSAFilter.forEach((tSA) => {
              const subActividad = subactividades.find(
                (sa) =>
                  sa.actividad_id == this.actividadesMapa.get(10).id &&
                  sa.tipo_subactividad_id == tSA.id
              );
              let subActividadEspecies = null;
              if (subActividad) {
                subActividadEspecies = subActividadesEspecie.filter(
                  (sae) => sae.subactividad_id == subActividad.id
                );
              }

              let poseeActividad = false;
              let actividadDependencia = '';
              let listaEspDelTipo: Especie[] = [];
              switch (tSA.id) {
                // Campo o maquinaria
                case 1:
                case 2: {
                  poseeActividad = this.verStep(9);
                  actividadDependencia = 'Produccion';

                  const actProd = this.actividadesMapa.get(9);
                  //encuertra los grupos de actividad asociados a esa actividad
                  if (actProd) {
                    const listaAGE = actividadesGruposEspecie.filter(
                      (gE) => gE.actividad_id == actProd.id
                    );

                    listaEspDelTipo = [];
                    for (const aGE of listaAGE) {
                      const listaEspPorGrupoEsp = especies.filter((e) =>
                        e.grupos_especie_id.includes(aGE.grupo_especie_id)
                      );
                      listaEspDelTipo =
                        listaEspDelTipo.concat(listaEspPorGrupoEsp);
                    }
                  }
                  break;
                }
                // Etiquetado
                case 3: {
                  poseeActividad = true;
                  listaEspDelTipo = especies;
                  break;
                }
                // Planta de procesamiento
                case 4: {
                  poseeActividad = this.verStep(8);
                  actividadDependencia = 'Procesamiento';
                  const actProd = this.actividadesMapa.get(8);
                  listaEspDelTipo = especies;
                  break;
                }
                // Laboratorio
                case 5: {
                  poseeActividad = this.verStep(7);
                  actividadDependencia = 'Laboratorio';
                  const actProd = this.actividadesMapa.get(7);
                  //encuertra los grupos de actividad asociados a esa actividad
                  if (actProd) {
                    // Obtengo el laboratorio y de ahi las especies
                    const labsEntidadProductiva = laboratorios.filter(
                      (l) => l.entidad_productiva_id == actProd.id
                    );
                    listaEspDelTipo = [];
                    for (const lab of labsEntidadProductiva) {
                      const listaEspeciesLaboratorio = especies.filter(
                        (e) =>
                          lab.analisis_especie.find(
                            (ae) => ae.especie_id == e.id
                          ) && !listaEspDelTipo.includes(e)
                      );
                      listaEspDelTipo = listaEspDelTipo.concat(
                        listaEspeciesLaboratorio
                      );
                    }
                  }
                  break;
                }
              }

              let listaEspeciesDelTipo: CheckItem[] = [];
              for (const eDT of listaEspDelTipo) {
                listaEspeciesDelTipo.push({
                  id: eDT.id,
                  tipo_id: null,
                  nombre: eDT.nombre_comun
                    ? eDT.nombre_comun
                    : eDT.nombre_cientifico,
                  selected: subActividadEspecies?.find(
                    (sae) => sae.especie_id == eDT.id
                  )
                    ? true
                    : false //ver como cargar datos de la api
                });
              }

              const rAAIFI: RegistroActividadAcreditacionItemFormInput = {
                poseeActividad: poseeActividad,
                actividadDependencia: actividadDependencia,
                tipoSubActividad: tSA,
                listaEspeciesDelTipo: listaEspeciesDelTipo,
                seleccionada: subActividad ? true : false
              };
              this.regActAcreFormInput.listaRegActAcr.push(rAAIFI);
            });
            this.regActAcreFormInput.actividad_id =
              this.actividadesMapa.get(10).id;
            //this.tipoSubActividadInput.listaTipoSubActividad = tSAFilter;
          }
        } else {
          this.idEmpresa = null;
          this.router.navigate(['/vista-mis-empresas']);
          return;
        }
      }
    );
    this.firstFormGroup = this.fb.group({
      firstCtrl: ['', Validators.required]
    });

    // Next step
    const s2 = this.store.select(selectStepperActividad).subscribe((s) => {
      this.onNextStep();
    });
    this.subscriptions.push(s2);
  }

  verStep(idTipoActividad: number): boolean {
    let salida = false;
    if (this.actividadesMapa?.get(idTipoActividad)?.estado_actividad_id === 1) {
      salida = true;
    }
    return salida;
  }

  formValueChanges(event: any) {}

  formStatusChanges(event: any) {}

  onSiguiente() {}

  onCancel() {}

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onNextStep() {
    if (this.stepper) {
      this.stepper.selected.completed = true;
      this.stepper.next();
    }
  }
}
